import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import manOlderPNG from '~/assets/images/anatomy/interstitial-curiosity-man-older.png'
import manOlderWEBP from '~/assets/images/anatomy/interstitial-curiosity-man-older.webp'
import manYoungPNG from '~/assets/images/anatomy/interstitial-curiosity-man-young.png'
import manYoungWEBP from '~/assets/images/anatomy/interstitial-curiosity-man-young.webp'
import womenOlderPNG from '~/assets/images/anatomy/interstitial-curiosity-women-older.png'
import womenOlderWEBP from '~/assets/images/anatomy/interstitial-curiosity-women-older.webp'
import womenYoungPNG from '~/assets/images/anatomy/interstitial-curiosity-women-young.png'
import womenYoungWEBP from '~/assets/images/anatomy/interstitial-curiosity-women-young.webp'
import { CURIOSITY_INTERSTITIAL_QUESTION } from '~/pages/anatomy/curiosityInterstitial/constants'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { TImageVariantWithAlt } from '~/pages/anatomy/libs/types'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const OLDER_AGE_VALUES = new Set(['50', '60', '65'])

const IMAGE_VARIANTS: Record<string, TImageVariantWithAlt> = {
  'female-young': {
    png: womenYoungPNG,
    webp: womenYoungWEBP,
    alt: 'Woman young curiosity',
  },
  'female-older': {
    png: womenOlderPNG,
    webp: womenOlderWEBP,
    alt: 'Woman older curiosity',
  },
  'male-young': {
    png: manYoungPNG,
    webp: manYoungWEBP,
    alt: 'Man young curiosity',
  },
  'male-older': {
    png: manOlderPNG,
    webp: manOlderWEBP,
    alt: 'Man older curiosity',
  },
}

const CuriosityInterstitial = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: CURIOSITY_INTERSTITIAL_QUESTION,
  })

  const answers = useSelector(selectAnswers)
  const gender = String(answers?.['gender-1'] ?? 'female')
  const age = String(answers?.['age-1'] ?? '')
  const ageGroup = OLDER_AGE_VALUES.has(age) ? 'older' : 'young'
  const variantKey = `${gender}-${ageGroup}`
  const image = IMAGE_VARIANTS[variantKey] ?? IMAGE_VARIANTS['female-young']

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={image.webp} type="image/webp" />
            <img src={image.png} alt={image.alt} />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans
            ns="anatomy"
            i18nKey="onboarding.curiosityInterstitial.title"
            components={{ br: <br /> }}
          />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="anatomy"
            i18nKey="onboarding.curiosityInterstitial.subtitle"
          />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default CuriosityInterstitial
